export default __webpack_public_path__ + "static/media/fsi3.ceeba147.gif";